import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSideBarExpand: true,
  breadcrumbObj: {
    routes: [],
    name: "",
  },
};

const CutomizerSlice = createSlice({
  name: "customizer",
  initialState,
  reducers: {
    expandShrinkSidebar: (state, action) => {
      state.isSideBarExpand = action.payload;
    },
    setBreadcrumbObj: (state, action) => {
      state.breadcrumbObj = action.payload;
    },
  },
});

export const { expandShrinkSidebar, setBreadcrumbObj } = CutomizerSlice.actions;
export default CutomizerSlice.reducer;
